var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemLikeIconFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.53 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.51,14.18,32.6,23.72a4.26,4.26,0,0,1-3.22,3.35,32.31,32.31,0,0,1-7.3.93c-.46,0-.92,0-1.39,0a42.19,42.19,0,0,1-8.29-1.45.91.91,0,0,1-.67-.42.89.89,0,0,1-.13-.56V14.33c0-.08,0-.19,0-.33a2.62,2.62,0,0,1,.06-.8,1.38,1.38,0,0,1,.41-.63,8.45,8.45,0,0,0,1.62-1.26,9.65,9.65,0,0,0,2-2.88l2.95-6.74A2.82,2.82,0,0,1,24,3.28l-.83,5a2.24,2.24,0,0,0,2.22,2.62h6.44a2.74,2.74,0,0,1,2.67,3.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.15,14V25.34a2.73,2.73,0,0,1-.07.64A2.66,2.66,0,0,1,7.5,28H2.64A2.66,2.66,0,0,1,0,25.34V14a2.66,2.66,0,0,1,2.66-2.66H7.5A2.66,2.66,0,0,1,10.15,14Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLikeIconFill);
export default __webpack_public_path__ + "static/media/item_like_icon_fill.304369099931001db0e0f8a46ae3ab56.svg";
export { ForwardRef as ReactComponent };